import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Browseobligor } from '../Models/browseobligor';
import { InvestorBrowseFilings } from '../Models/investor-browse-filings';
import { QA } from '../Models/qa';
import { Webcast } from '../Models/webcast';
import { InvestorBrowse } from '../Models/investor-browse';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const httpGetOptions =
{
  withCredentials: true,
};

@Injectable({
  providedIn: 'root'
})

export class BrowseobligorService {

  APIURL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // Get BrowseObligors with Search Obligors Filter
  GetDataSearchObligors(SearchObligorsValue: string): Observable<Browseobligor> {
    debugger;
    return this.http.get<Browseobligor>(this.APIURL + 'InvestorBrowseObligors?obligorDescSubstring=' + SearchObligorsValue, httpGetOptions);
  }

  // Get BrowseObligors with Alphabetical Filter
  GetInvestorBrowseObligors(AlphabeticalChar: string): Observable<Browseobligor> {
    debugger;
    return this.http.get<Browseobligor>(this.APIURL + 'InvestorBrowseObligors?obligorDescLetter=' + AlphabeticalChar, httpGetOptions);
  }

  // Get BrowseObligors with Filing History
  GetInvestorBrowseFilingsWithFilingType(obligorId: string, filingType: string): Observable<InvestorBrowseFilings> {
    debugger;
    return this.http.get<InvestorBrowseFilings>(this.APIURL + 'InvestorBrowseFilings?obligorId=' + obligorId + '&filingType=' + filingType, httpGetOptions);
  }

  // Q&A add question
  AddQA(obligorId: string, subject: string, question: string): Observable<QA> {
    debugger;
    let payload = [
      { "obligorId": obligorId, "subject": subject, "question": question }
    ];

    return this.http.post<QA>(this.APIURL + "InvestorQAForumAddQuestion", payload, httpOptions);
  }

  // GetWebCast
  GetWebCast(obligorId: string): Observable<Webcast> {
    debugger;
    return this.http.get<Webcast>(this.APIURL + 'InvestorBrowseWebcasts?obligorId=' + obligorId, httpGetOptions);
  }

  // Alerts
  SendAlerts(obligorId: string, enableAlert: string) {
    debugger;
    let payload = [
      { "obligorId": obligorId, "enableAlert": enableAlert }
    ];

    return this.http.post<Browseobligor>(this.APIURL + "InvestorObligorsUpdateAlerts", payload, httpOptions);
  }

  // Get InvestorBrowseFilingTypes
  GetInvestorBrowseFilingTypes(obligorId: string): Observable<Browseobligor> {
    debugger;
    return this.http.get<Browseobligor>(this.APIURL + 'InvestorBrowseFilingTypes?obligorId=' + obligorId, httpGetOptions);
  }

  // Get InvestorBrowseBorrowingDocuments
  GetInvestorBrowseBorrowingDocuments(obligorId: string, outstanding: string): Observable<InvestorBrowse> {
    debugger;
    return this.http.get<InvestorBrowse>(this.APIURL + 'InvestorBrowseBorrowingDocuments?obligorId=' + obligorId + '&outstanding=' + outstanding, httpGetOptions);
  }
}
